/**
 * External Dependencies
 */
import ScrollXP from 'scrollxp';
import 'jquery';

$(() => {
    let view = new ScrollXP({
        container: document.body,
      })
      //TODO: Change reverse to false
      view.setDefault(new ScrollXP.Scene().reverse(false).build())
      view.setDefault(new ScrollXP.Animation().fromY(80).toY(0).fromAlpha(0).toAlpha(1).ease('sine.inOut').build())
      
      let fadeIn = new ScrollXP.Animation('fade-in').fromAlpha(0).toAlpha(1).ease('sine.inOut').build()
      let fadeInFromLeft = new ScrollXP.Animation('fade-left').fromX(-80).toX(0).fromAlpha(0).toAlpha(1).ease('circle.Out').build()
      let fadeInFromRight = new ScrollXP.Animation('fade-right').fromX(80).toX(0).fromAlpha(0).toAlpha(1).ease('cirlce.Out').build()
      view.register(fadeIn)
      view.register(fadeInFromLeft)
      view.register(fadeInFromRight)

    $(window).ready(function () {
        if (getCookie('animationCookie') === 'animationSeen') {
            document.body.className = document.body.className.replace('first-load-animation', '');
        } else {
            setAnimationCookie('animationCookie', 'animationSeen', 1);
        }
    });
    function setAnimationCookie(name, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + cvalue + '; ' + expires;
    }
    function getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    }
});
